<template>
    <div>
        <div class="box">
            <div class="top-bar">
                <b-button @click="$router.go(-1)" class="level-item" type="is-light">
                    <b-icon icon="arrow-left" pack="fas" />
                    <span>Back</span>
                </b-button>
                <p class="sub-title">{{ isEdit ? "Edit" : "New" }} {{ itemName }}</p>
            </div>
            <hr />
            <div>
                <form @submit.prevent="formSubmit">
                    <b-field label="ID">
                        <b-input disabled v-model="form.id" />
                    </b-field>
                    <b-field
                        v-for="(ele, index) in elements"
                        :key="index"
                        :label="ele.label"
                        :message="form.errors.get(ele.field)"
                        :type="{ 'is-danger': form.errors.has(ele.field) }"
                    >
                        <!-- BInput -->
                        <b-input
                            v-if="ele.element === 'text'"
                            :type="ele.type"
                            v-model="form[ele.field]"
                            :maxlength="ele.max"
                            :required="ele.required"
                            :disabled="ele.disabled"
                            :max="ele.max"
                            :min="ele.min"
                        />
                        <!-- BSelect -->
                        <b-select
                            v-if="ele.element === 'select'"
                            placeholder="Select"
                            v-model="form[ele.field]"
                            expanded
                            :required="ele.required"
                            :disabled="ele.disabled"
                        >
                            <option v-for="(val, idx) in ele.values" :key="idx" :value="val.value">{{ val.name }}</option>
                        </b-select>
                        <!-- BCheckbox -->
                        <div class="block" v-if="ele.element === 'checkbox'">
                            <b-checkbox v-for="(val, idx) in ele.values" :key="idx" v-model="form[ele.field]" :native-value="val.value">
                                {{ val.name }}
                            </b-checkbox>
                        </div>
                        <!-- Gallery File Selection -->
                        <GalleryPicker
                            v-if="ele.element === 'gallery'"
                            :multiple="ele.multiple"
                            :type="ele.value"
                            @select="(id) => (form[ele.field] = id)"
                            :initial="form[ele.init_value_field]"
                        />
                    </b-field>

                    <div class="bottom-btns">
                        <b-button @click="$router.go(-1)" type="is-light">Cancel</b-button>
                        <b-button :loading="form.busy" native-type="submit" type="is-primary">Submit</b-button>
                    </div>
                </form>
                <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
            </div>
        </div>
    </div>
</template>

<script>
import vform from "../../../plugins/vForm";
import GalleryPicker from "../../../components/Files/GalleryPicker.vue";
export default {
    components: {
        GalleryPicker,
    },
    data() {
        return {
            itemName: "User",
            apiURI: "/users",
            isLoading: true,
            form: new vform({
                id: "",
                username: "",
                password: undefined,
                active: 1,
                privileges: [],
            }),
            elements: [
                {
                    label: "Username",
                    field: "username",
                    max: 55,
                    type: "text",
                    element: "text",
                    disabled: this.$route.path.indexOf("new") == -1 ? true : false,
                },
                {
                    label: "Password",
                    field: "password",
                    min: 8,
                    type: "password",
                    element: "text",
                },
                {
                    label: "Active",
                    field: "active",
                    required: true,
                    element: "select",
                    values: [
                        { name: "Active", value: 1 },
                        { name: "Disabled", value: 0 },
                    ],
                },
                {
                    label: "Privileges",
                    field: "privileges",
                    element: "checkbox",
                    values: this.$store.state.all_privileges,
                },
            ],
        };
    },
    methods: {
        async init() {
            let id = this.$route.params.id;
            // Edit Loading
            if (this.isEdit) {
                // If its not Number
                if (!id || !this.isNumber(id)) {
                    this.notify("Error fetching data.", "is-danger");
                    return;
                }
                try {
                    let res = await this.$http.get(`${this.apiURI}/${id}`);
                    res.data.active = res.data.active ? 1 : 0;
                    this.form.fill(res.data);
                } catch (err) {
                    this.notify(err, "is-danger");
                    return;
                }
            }
            this.isLoading = false;
        },
        formSubmit() {
            if (this.isEdit) {
                // Edit request
                this.form.password = this.form.password == "" ? undefined : this.form.password;
                let update = () => {
                    this.form
                        .submit("post", this.apiURI + "/" + this.form.id, {}, true)
                        .then(() => {
                            //Alert
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.itemName + " editied successfully.",
                                type: "is-success",
                            });
                            this.$router.go(-1);
                            // this.$store.dispatch("loadAPI", this.$axios);
                        })
                        .catch((err) => {
                            if (err.response.status != 422) {
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: "Something went wrong.",
                                    position: "is-bottom",
                                    type: "is-danger",
                                });
                            }
                        });
                };
                if (this.form.password) {
                    // Password changed, alert for password change
                    this.$buefy.dialog.confirm({
                        title: "Changing password",
                        message: "Are you sure you want to change the <b>password</b> this user? This action cannot be undone.",
                        confirmText: "Confirm",
                        type: "is-warning",
                        hasIcon: true,
                        onConfirm: update,
                    });
                } else {
                    update();
                }
            } else {
                // Create request
                this.form
                    .submit("post", this.apiURI, {}, true)
                    .then(() => {
                        //Alert
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: this.itemName + " created successfully.",
                            type: "is-success",
                        });
                        this.$router.go(-1);
                        // this.$store.dispatch("loadAPI", this.$axios);
                    })
                    .catch((err) => {
                        if (err.response.status != 422) {
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: "Something went wrong. Please try again.",
                                position: "is-bottom",
                                type: "is-danger",
                            });
                        }
                    });
            }
        },
    },
    created() {},
    mounted() {
        this.init();
    },
    computed: {
        isEdit() {
            if (this.$route.path.indexOf("new") == -1) {
                return true;
            }
            return false;
        },
    },
};
</script>

<style>
.block {
    display: block;
}
.modal-form {
    position: relative;
}
img.preview-image {
    max-height: 180px;
    border-radius: 10px;
}
</style>
